import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { Link } from 'react-router-dom'

export default function Sitemap() {
  return (
    <>
      <Header currentPage="sitemap" />

      {/* Page Header */}
      <section className="py-16 bg-gray-50 pt-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            SITEMAP
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Find all pages and resources on our website
          </p>
        </div>
      </section>

      {/* Sitemap Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 md:p-12">
            
            <div className="space-y-8">
              {/* Main Pages */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">Main Pages</h2>
                <ul className="space-y-2 text-gray-700">
                  <li><Link to="/" className="text-blue-600 hover:text-blue-800">Home</Link></li>
                  <li><Link to="/services" className="text-blue-600 hover:text-blue-800">Services</Link></li>
                  <li><Link to="/work" className="text-blue-600 hover:text-blue-800">Our Work</Link></li>
                  <li><Link to="/about" className="text-blue-600 hover:text-blue-800">About</Link></li>
                  <li><Link to="/contact" className="text-blue-600 hover:text-blue-800">Contact</Link></li>
                  <li><Link to="/join-our-team" className="text-blue-600 hover:text-blue-800">Join Our Team</Link></li>
                </ul>
              </div>

              {/* Services */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">Services</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Residential</h3>
                    <ul className="space-y-2 text-gray-700 ml-4">
                      <li><Link to="/services?category=residential" className="text-blue-600 hover:text-blue-800">Custom Home Construction</Link></li>
                      <li><Link to="/services?category=residential" className="text-blue-600 hover:text-blue-800">Hardscapes</Link></li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Commercial</h3>
                    <ul className="space-y-2 text-gray-700 ml-4">
                      <li><Link to="/services?category=commercial" className="text-blue-600 hover:text-blue-800">Precast Concrete</Link></li>
                      <li><Link to="/services?category=commercial" className="text-blue-600 hover:text-blue-800">Consulting & Project Planning</Link></li>
                      <li><Link to="/services?category=commercial" className="text-blue-600 hover:text-blue-800">Architectural & Specialty Concrete Formwork</Link></li>
                      <li><Link to="/services?category=commercial" className="text-blue-600 hover:text-blue-800">Mass Timber Installation</Link></li>
                      <li><Link to="/services?category=commercial" className="text-blue-600 hover:text-blue-800">Panelized Building Envelope Installation</Link></li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Legal & Info */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">Legal & Information</h2>
                <ul className="space-y-2 text-gray-700">
                  <li><Link to="/terms-of-service" className="text-blue-600 hover:text-blue-800">Terms of Service</Link></li>
                  <li><Link to="/sitemap" className="text-blue-600 hover:text-blue-800">Sitemap</Link></li>
                </ul>
              </div>

              {/* Contact Info */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">Contact Information</h2>
                <ul className="space-y-2 text-gray-700">
                  <li>Email: <a href="mailto:support@taktcon.com" className="text-blue-600 hover:text-blue-800">support@taktcon.com</a></li>
                  <li>Phone: <a href="tel:+16048428258" className="text-blue-600 hover:text-blue-800">(604) 842-8258</a></li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

